let vue;

export default {
  getVue() {
    return vue;
  },
  setVue(v) {
    vue = v;
  },
};
